import { render } from "./ClaimsIndex.vue?vue&type=template&id=2faa5cca"
import script from "./ClaimsIndex.vue?vue&type=script&lang=js"
export * from "./ClaimsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__